import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { playSound } from 'containers/App/actions';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import withSoundLoader from 'utils/withSoundLoader';
import wheelAward from './sounds/WheelAwardSound.mp3';
import wheelButton from './sounds/WheelButtonPress.mp3';
import wheelPointer from './sounds/WheelPointerSound.mp3';

export const WHEEL_POINTER_SOUND = 'wheelPointer';
export const WHEEL_BUTTON_SOUND = 'wheelButton';
export const WHEEL_AWARD_SOUND = 'wheelAward';

const BALANCE_WHEEL_SOUNDS = {
  [WHEEL_POINTER_SOUND]: {
    src: [wheelPointer],
    volume: 1
  },
  [WHEEL_BUTTON_SOUND]: {
    src: [wheelButton],
    volume: 1
  },
  [WHEEL_AWARD_SOUND]: {
    src: [wheelAward],
    volume: 1
  }
};

function withWheelSounds(WrappedComponent) {
  class Sounds extends Component {
    render() {
      const { triggerSound, casinoSoundsOn, ...otherProps } = this.props;

      return (
        <WrappedComponent
          playSegmentChange={() => {
            if (casinoSoundsOn) triggerSound(WHEEL_POINTER_SOUND);
          }}
          playSpinStart={() => {
            if (casinoSoundsOn) triggerSound(WHEEL_BUTTON_SOUND);
          }}
          playSpinEnd={() => {
            if (casinoSoundsOn) triggerSound(WHEEL_AWARD_SOUND);
          }}
          {...otherProps}
        />
      );
    }
  }

  Sounds.propTypes = {
    triggerSound: PropTypes.func,
    casinoSoundsOn: PropTypes.bool
  };

  function mapDispatchToProps(dispatch) {
    return {
      triggerSound: sound => dispatch(playSound(sound))
    };
  }

  const mapStateToProps = createStructuredSelector({
    casinoSoundsOn: makeSelectCasinoSoundsOn()
  });

  const withConnect = connect(mapStateToProps, mapDispatchToProps);
  const withWheelSoundLoader = withSoundLoader(BALANCE_WHEEL_SOUNDS, true);

  return withConnect(withWheelSoundLoader(Sounds));
}

export default withWheelSounds;
